if($('header#header').length){
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.top-navigation-tools .dropdown').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('<span class="close"></span>').appendTo('.search');
    $('header#header').before($('.header-top .search').clone().addClass('customSearch'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')  
    $('<span class="close"></span>').appendTo('.popup-widget-inner');
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $(document).on("click", ".search .close", function(){
        $('body').removeClass('user-action-visible search-window-visible')
        $('.search input.search-input').val('')
    })
    $(document).on("click", ".login-widget .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.search').length || clickedElement.is('a[data-target="search"]'))) {
            $('body').removeClass('search-window-visible user-action-visible');
            $('.search input.search-input').val('')
        }
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    }); 
}